import React from 'react';

import { translate } from "react-i18next";
import { Form, Row, Col } from 'react-bootstrap';
import '../App.css';
import { PUB_CATEGORIES } from '../../backend/Data';
import { getTransValue } from "../../backend/UIUtils";
import i18n from "i18next";
import FileUpload from '../util/FileUpload';

class PublicEventSelectCategory extends React.Component {

    constructor(props) {
        super(props);
        this.onFileChange = this.onFileChange.bind(this);


        this.state = {
            event: this.props.detailModel,
            selectedCat : null
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    onInputChange(e) {
        const { event } = this.state;
        const { name: fieldName, value: fieldValue } = e.target;

        let oldState = this.state;

        let selectedCat = this.state.selectedCat;
        if (e.target.name === 'eventCategory') {
            if("0" === e.target.value){
                selectedCat = null;
            } else {
                let filteredcat = PUB_CATEGORIES.filter(cat => cat.code === e.target.value);
                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
            }
        }

        //let selectedSubCat = this.state.event.subCategory;

        const newEvent = {
            ...event,
            eventCategory: selectedCat? selectedCat.code : null,
            [fieldName]: fieldValue
        };
        this.props.updateModel("eventCategory", newEvent);
    
        this.setState({
            ...oldState,
            event: newEvent,
            selectedCat: selectedCat
        });

    }

    onFileChange(e) {
        //console.log("file " + e.target.files[0].name);
        //console.log("file " + e.target.files[0].length);
        //console.log("initial event " + JSON.stringify(this.state.event));
        let oldEvent = this.state.event;

        const newEvent = {
            ...oldEvent,
            file: e.target.files[0]
        };
        this.props.updateModel("eventCategory", newEvent);

        this.setState({
            event: newEvent
        });
    }


    render() {
        const { t } = this.props;
        let lang = i18n.language;
        const { event: { title, description, eventCategory, subCategory , file} } = this.state;
        return (
            <div className="col-md-12 ">
                <Row className="mt-3">
                    <Col lg={12} md={12}>
                        <Form.Control value={title}
                            name="title"
                            onChange={this.onInputChange}
                            placeholder={t("eventTitle")}
                            maxLength={250}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col lg={6} md={12}>
                            <Form.Control as="select" name="eventCategory" value={eventCategory} onChange={this.onInputChange} defaultValue="0">
                                <option value="0">{t("catChoose")}</option>
                                { PUB_CATEGORIES.map(c =>
                                    <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                )}
                            </Form.Control>
                   </Col>
                    <Col lg={6} md={12}>
                            <Form.Control as="select" name="subCategory" value={subCategory} onChange={this.onInputChange}  
                             disabled={!this.state.selectedCat} >
                                 {!this.state.selectedCat ?
                                    <option value="0">{t("subCatChoose")}</option>
                                    :
                                    ''
                                 }
                               
                                {this.state.selectedCat ?
                                    this.state.selectedCat.subs.map(c =>
                                        <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                    )
                                    : ''
                                }
                            </Form.Control>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12} md={12}>
                        <Form.Control as="textarea" value={description}
                            name="description" onChange={this.onInputChange}
                            placeholder={t("eventDescription")} className="mt-2 "
                            rows="5" maxLength={2000}/>
                    </Col>
                </Row>
                <Row className="pt-2 pb-2">
                    <Col lg={12} md={12} >
                        <FileUpload fileChanged={this.props.fileChanged} showRemove={true}/>
                    </Col>
                </Row>

               
            </div>);

    }

}

export default translate("translations")(PublicEventSelectCategory);